import { api } from '@/api/client'

/** Marca a sessão atual como PWA persistente (~10a) no servidor. */
export async function persistPwaSession(): Promise<void> {
  await api.post('/v1/me/session/pwa')
}
